import { useState, useEffect } from 'react';
/* eslint-disable */

import { Paper, Typography, Box, Button } from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import BiometricDevices from 'views/Components/BiometricDevices/BiometricDevices';
import { handleCapture } from 'views/Components/BiometricDevices/BiometricCapture';
import fingerScan from 'assets/gif/Finger_print_scanning.gif';
import { useSelector } from 'react-redux';

export default function AuthenticationBox({ onCapture, onStatusChange, tabIndex, disableScanButton = false, responseStatus }) {
    const [selectedDeviceName, setSelectedDeviceName] = useState('');
    const [showDeviceList, setShowDeviceList] = useState(false);
    const [isScanning, setIsScanning] = useState(false);
    const [authStatus, setAuthStatus] = useState('idle');
    console.log('authStatus', authStatus);

    const [location, setLocation] = useState({ latitude: '', longitude: '' });
    const isReset = useSelector((state) => state.reset.isReset);

    const handleDeviceSelect = (deviceName) => {
        setSelectedDeviceName(deviceName);
        setShowDeviceList(false);
    };

    const onCaptureSuccess = (data) => {
        setIsScanning(false);
        if (data && data !== false) {
            setAuthStatus('success');
            if (typeof onCapture === 'function') onCapture(data);
        } else {
            setAuthStatus('error');
        }
    };

    useEffect(() => {
        if (selectedDeviceName) {
            setIsScanning(true);
            setAuthStatus('scanning');

            const timeoutId = setTimeout(() => {
                handleCapture(selectedDeviceName, onCaptureSuccess);
            }, 1000);

            return () => {
                clearTimeout(timeoutId);
                setIsScanning(false);
            };
        }
    }, [selectedDeviceName]);

    useEffect(() => {
        if (typeof onStatusChange === 'function') {
            onStatusChange(authStatus, location);
        }
    }, [authStatus, location, onStatusChange]);

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            },
            (error) => {
                console.error(error);
            }
        );
    }, []);

    const handleRetry = () => {
        setSelectedDeviceName('');
        setAuthStatus('idle');
        setIsScanning(false);
        setShowDeviceList(true);

        if (typeof onStatusChange === 'function') {
            onStatusChange('idle', location);
        }
    };

    const renderIcon = () => {
        switch (authStatus) {
            case 'scanning':
                return (
                    <Box>
                        <img src={fingerScan} alt="Scanning..." style={{ width: 60, height: 60 }} />
                    </Box>
                );
            case 'success':
                return <CheckCircleIcon sx={{ fontSize: 60, color: 'green' }} />;
            case 'error':
                return <ErrorIcon sx={{ fontSize: 60, color: 'red' }} />;
            default:
                return <FingerprintIcon sx={{ fontSize: 60, color: '#888' }} />;
        }
    };

    const renderMessage = () => {
        switch (authStatus) {
            case 'scanning':
                return 'Scanning fingerprint...';
            case 'success':
                return 'Authentication successful';
            case 'error':
                return 'Authentication failed. Try again.';
            default:
                return 'Place your finger on the device';
        }
    };

    useEffect(() => {
        setSelectedDeviceName('');
        setShowDeviceList(false);
        setIsScanning(false);
        setAuthStatus('idle');

        if (typeof onStatusChange === 'function') {
            onStatusChange('idle', location);
        }
    }, [tabIndex, isReset]);

    return (
        <>
            <Paper elevation={3} sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                    Authentication
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                    <Box sx={{ textAlign: 'center' }}>
                        {renderIcon()}
                        <Typography mt={1}>{renderMessage()}</Typography>
                    </Box>
                </Box>

                {authStatus === 'error' || responseStatus === false ? (
                    <Button variant="contained" color="error" onClick={handleRetry} sx={{ mt: 2 }} disabled={disableScanButton}>
                        Retry
                    </Button>
                ) : (
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => setShowDeviceList(!showDeviceList)}
                        sx={{ mt: 2 }}
                        disabled={isScanning || disableScanButton}
                    >
                        {'Select Device'}
                    </Button>
                )}

                {selectedDeviceName && (
                    <Typography variant="body2" mt={1}>
                        Selected Device: <strong>{selectedDeviceName}</strong>
                    </Typography>
                )}

                {showDeviceList && (
                    <Box mt={2}>
                        <BiometricDevices onDeviceSelect={handleDeviceSelect} service={'AEPS'} />
                    </Box>
                )}
            </Paper>
            {/* )} */}
        </>
    );
}
